import React from 'react'

const paths={
 megaphone:'M3 9h4l12-5v16L7 15H3zM7 9v6M7 15l2 6h3l-2-5M22 9v6',
 users:'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
 building:'M4 21V3h16v18zM9 21v-4h6v4M8 7h1M15 7h1M8 11h1M15 11h1M8 14h1M15 14h1',
 clipboard:'M9 5H5v16h14V5h-4M9 3h6v4H9zM8 11h8M8 15h8',
 gear:'M9.7 4.5 10.3 2h3.4l.6 2.5 1.8 1 2.5-.7 1.7 2.9-1.8 1.8v2.1l1.8 1.8-1.7 2.9-2.5-.7-1.8 1-.6 2.5h-3.4l-.6-2.5-1.8-1-2.5.7-1.7-2.9 1.8-1.8V9.5L3.7 7.7l1.7-2.9 2.5.7z',
}
export default function FlatIcon({name,size=24}){
 return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><g transform={name==='gear'?'translate(0 1.5)':undefined}><path d={paths[name]}/>{name==='gear'&&<circle cx="12" cy="10.65" r="3"/>}</g></svg>
}
